import {Highlight, Shortcoming} from '@dms/shared';

import {FeaturesType} from '../../../types/FeaturesType';
import {HighlightItemType} from '../types/HighlightItemType';

/**
 * Order of the flags: user highlights → shortcomings → interior material
 * → highlighted features.
 */
export const convertVehicleTagsToVehicleHighlights = (
  highlights: Highlight[],
  shortcomings: Shortcoming[],
  features: FeaturesType[],
  interiorMaterial: HighlightItemType[] = []
): HighlightItemType[] => {
  const sortedHighlightes: HighlightItemType[] = highlights
    .map((item) => ({
      key: item.id,
      label: item.title,
      size: 'small' as const,
      colorScheme: 'neutral' as const,
      isSubtle: true,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const sortedShortcomings: HighlightItemType[] = shortcomings
    .map((item) => ({
      key: item.id,
      label: item.title,
      size: 'small' as const,
      colorScheme: 'red' as const,
      isSubtle: true,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const sortedFeatures: HighlightItemType[] = features
    .map((item) => ({
      key: item.key,
      label: item.translation,
      size: 'small' as const,
      colorScheme: 'blue' as const,
      isSubtle: true,
      // icon: item.isPremium ? <Icon value="toggle/star" /> : undefined,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return [...sortedHighlightes, ...sortedShortcomings, ...interiorMaterial, ...sortedFeatures];
};
